// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","foldingCube":"Loader_foldingCube__sfl7K","cube":"Loader_cube__PqOeF","foldCubeAngle":"Loader_foldCubeAngle__IvWGo"};